import React from 'react';
import { StyledLabel, StyledWrapper } from './yearEndFinancialDate.styles';

interface YearEndFinancialLabelProps {
  text: string;
}

const YearEndFinancialLabel = (props: YearEndFinancialLabelProps) => {
  const { text } = props;

  return (
    <StyledWrapper>
      <StyledLabel>
        <label>{text}</label>
      </StyledLabel>
    </StyledWrapper>
  );
};

export default YearEndFinancialLabel;
